import React, { useState, useEffect, useRef, useCallback, useMemo } from 'react';
import { connect } from 'react-redux';
import { loaderStateTrue, loaderStateFalse, handleActiveLink } from '../../../Actions/AllAction';
import CustomInput from '../../Utility/Components/CustomInput'
import ErrorBoundary from '../../Utility/Components/ErrorBoundary';
import { withNamespaces } from 'react-i18next';
function BankDetailsContent(props) {
    return (
        <>
            <div className='col-md-12'>
                <h3 className='admin_details_label'>Bank details</h3>
                <div className='divider_row'></div>
            </div>
            <div className="col-md-12">
                <div className="row">
                    <div className="col-md-4">
                        <ErrorBoundary title="CustomInput Error">
                            <CustomInput
                                parentClassName="input_field_inner"
                                labelName="Bank Name"
                                errorLabel={props.errorFormData.bank_name}
                                name="bank_name"
                                type="text"
                                value={props.formData.bank_name}
                                labelPresent={true}
                                onChange={(e) => props.handelChange(e, 'bank_name')}
                                requiredStar={false}
                            />
                        </ErrorBoundary>
                    </div>
                    <div className="col-md-4">
                        <ErrorBoundary title="CustomInput Error">
                            <CustomInput
                                parentClassName="input_field_inner"
                                labelName="Branch Name"
                                errorLabel={props.errorFormData.branch}
                                name="branch"
                                type="text"
                                value={props.formData.branch}
                                labelPresent={true}
                                onChange={(e) => props.handelChange(e, 'branch')}
                                requiredStar={false}
                            />
                        </ErrorBoundary>
                    </div>
                    <div className="col-md-4">
                        <ErrorBoundary title="CustomInput Error">
                            <CustomInput
                                parentClassName="input_field_inner"
                                labelName="Account Number"
                                errorLabel={props.errorFormData.account_no}
                                name="account_no"
                                type="text"
                                value={props.formData.account_no}
                                labelPresent={true}
                                onChange={(e) => props.handelChange(e, 'account_no')}
                                requiredStar={false}
                            />
                        </ErrorBoundary>
                    </div>
                    <div className="col-md-4">
                        <ErrorBoundary title="CustomInput Error">
                            <CustomInput
                                parentClassName="input_field_inner"
                                labelName="IFSC Code"
                                errorLabel={props.errorFormData.ifsc_code}
                                name="ifsc_code"
                                type="text"
                                value={props.formData.ifsc_code}
                                labelPresent={true}
                                onChange={(e) => props.handelChange(e, 'ifsc_code')}
                                requiredStar={false}
                            />
                        </ErrorBoundary>
                    </div>
                    <div className="col-md-4">
                        <ErrorBoundary title="CustomInput Error">
                            <CustomInput
                                parentClassName="input_field_inner"
                                labelName="Account Holder Name"
                                errorLabel={props.errorFormData.account_holder_name}
                                name="account_holder_name"
                                type="text"
                                value={props.formData.account_holder_name}
                                labelPresent={true}
                                onChange={(e) => props.handelChange(e, 'account_holder_name')}
                                requiredStar={false}
                            />
                        </ErrorBoundary>
                    </div>
                </div>
            </div>
        </>
    );
};

const mapStateToProps = (globalState) => {
    return {
        userCredentials: globalState.LoginReducer.userCredentials,
        token: globalState.LoginReducer.token
    };
}

export default connect(mapStateToProps, { handleActiveLink, loaderStateTrue, loaderStateFalse })(withNamespaces()(BankDetailsContent));
